export default {
  19001: {
    formName: 'Auto 43',
    formFromUrl: '19000',
    variantFromUrl: '1',
  },
  19002: {
    formName: 'Auto TU - 43',
    formFromUrl: '19000',
    variantFromUrl: '2',
  },
};
